import React, { FC, useState } from 'react';
import { StyledDrawerContent } from './styles';
import { Candidates } from './components/Candidates';
import { References } from './components/References';
import { MissingReferences } from './components/MissingReferences';
import { BrokenReferences } from './components/BrokenReferences';
import { Badge, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useReferencesContext } from './ReferencesContext';
import { AddLink, HelpOutline, Link, LinkOff } from '@mui/icons-material';

export default () => {
  return <TabsContainer />;
};

enum ReferenceTabs {
  References = 0,
  Missing = 1,
  Candidates = 2,
  Broken = 3,
}

const TabsContainer: FC = () => {
  const [selectedTab, setSelectedTab] = useState<ReferenceTabs>(ReferenceTabs.References);
  const { hasBrokenReferences, hasCandidates, hasMissingReferences, hasIeeeCitationLinks } = useReferencesContext();
  return (
    <>
      <Tabs sx={{ minHeight: '68px' }} variant="fullWidth" value={selectedTab} onChange={(_e, value) => setSelectedTab(value)}>
        <Tab
          label={
            <>
              <Link />
              <Typography variant="caption">Referanser</Typography>
            </>
          }
          value={ReferenceTabs.References}
        />
        <Tab
          label={
            <Badge color="error" variant="dot" overlap="circular" invisible={!hasMissingReferences}>
              <Stack alignItems={'center'}>
                <HelpOutline />
                <Typography variant="caption">Manglende</Typography>
              </Stack>
            </Badge>
          }
          value={ReferenceTabs.Missing}
        />
        <Tab
          label={
            <Badge color="error" variant="dot" overlap="circular" invisible={!hasCandidates && !hasIeeeCitationLinks}>
              <Stack alignItems={'center'}>
                <AddLink />
                <Typography variant="caption">Potensielle</Typography>
              </Stack>
            </Badge>
          }
          value={ReferenceTabs.Candidates}
        />
        <Tab
          label={
            <Badge color="error" variant="dot" overlap="circular" invisible={!hasBrokenReferences}>
              <Stack alignItems={'center'}>
                <LinkOff />
                <Typography variant="caption">Brutte</Typography>
              </Stack>
            </Badge>
          }
          value={ReferenceTabs.Broken}
        />
      </Tabs>
      <StyledDrawerContent>
        {selectedTab === ReferenceTabs.References && <References />}
        {selectedTab === ReferenceTabs.Missing && <MissingReferences />}
        {selectedTab === ReferenceTabs.Candidates && <Candidates />}
        {selectedTab === ReferenceTabs.Broken && <BrokenReferences />}
      </StyledDrawerContent>
    </>
  );
};
